import { Suspense } from 'react';
import {
  VenueBusinessSeats,
  VenueComps,
  VenueFoodBeverageContact,
  VenueInhouseTicketSystem,
  VenueMerch,
  VenueOverviewVersionSelect,
  VenueSuites,
  VenueSurcharges,
} from '@features';
import { Center, Grid, Skeleton, Stack } from '@mantine/core';

const COL_SPAN = { base: 12, md: 4 };

export const VenueDetailsOverviewPage: React.FC = () => {
  return (
    <Stack py="md" gap="xl">
      <Center>
        <Suspense fallback={<Skeleton height={40} w={200} />}>
          <VenueOverviewVersionSelect />
        </Suspense>
      </Center>
      <Grid>
        <Grid.Col span={COL_SPAN}>
          <Stack>
            <Suspense fallback={<Skeleton height={200} />}>
              <VenueSuites />
            </Suspense>
            <Suspense fallback={<Skeleton height={200} />}>
              <VenueBusinessSeats />
            </Suspense>
          </Stack>
        </Grid.Col>
        <Grid.Col span={COL_SPAN}>
          <Stack>
            <Suspense fallback={<Skeleton height={100} />}>
              <VenueSurcharges />
            </Suspense>
            <Suspense fallback={<Skeleton height={50} />}>
              <VenueComps />
            </Suspense>
            <Suspense fallback={<Skeleton height={50} />}>
              <VenueInhouseTicketSystem />
            </Suspense>
          </Stack>
        </Grid.Col>
        <Grid.Col span={COL_SPAN}>
          <Stack>
            <Suspense fallback={<Skeleton height={100} />}>
              <VenueMerch />
            </Suspense>
            <Suspense fallback={<Skeleton height={100} />}>
              <VenueFoodBeverageContact />
            </Suspense>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
